// Translate interface labels only; preserve the original values used by Odoo filters.
export function displayLabel(value = '') {
  return value
    .replace(/test client/gi, 'Tests à valider')
    .replace(/par le client/gi, 'de votre part')
    .replace(/du client/gi, 'de votre part')
    .replace(/retour client/gi, 'retour de votre part')
    .replace(/validation client/gi, 'validation de votre part')
    .replace(/attente client/gi, 'attente de votre retour');
}
